export const scoringCriteriaMappingOld = (
  t: (key: string) => string,
): Record<string, Record<string, string>> => ({
  location: {
    label: t('conversationShowLeadQualifierScoringCriteriaLocation'),
    icon: '📍',
  },
  products: {
    label: t('conversationShowLeadQualifierScoringCriteriaProducts'),
    icon: '🛒',
  },
  targetPrice: {
    label: t('conversationShowLeadQualifierScoringCriteriaTargetPrice'),
    icon: '💰',
  },
  productUsage: {
    label: t('conversationShowLeadQualifierScoringCriteriaProductUsage'),
    icon: '🏭',
  },
  monthlyVolume: {
    label: t('conversationShowLeadQualifierScoringCriteriaMonthlyVolume'),
    icon: '📦',
  },
  purchaseFrequency: {
    label: t('conversationShowLeadQualifierScoringCriteriaPurchaseFrequency'),
    icon: '📅',
  },
  acceptsCounterTypes: {
    label: t('conversationShowLeadQualifierScoringCriteriaAcceptsCounterTypes'),
    icon: '🔄',
  },
})

export const scoringCriteriaMappingNew = (
  t: (key: string) => string,
): Record<string, Record<string, string>> => ({
  location: {
    label: t('conversationShowLeadQualifierScoringCriteriaLocation'),
    icon: '📍',
  },
  quantityMOQ: {
    label: t('conversationShowLeadQualifierScoringCriteriaQuantityMOQ'),
    icon: '🔢',
  },
  businessContext: {
    label: t('conversationShowLeadQualifierScoringCriteriaBusinessContext'),
    icon: '🏢',
  },
  purchaseFrequency: {
    label: t('conversationShowLeadQualifierScoringCriteriaPurchaseFrequency'),
    icon: '📅',
  },
  productAvailability: {
    label: t('conversationShowLeadQualifierScoringCriteriaProductAvailability'),
    icon: '📦',
  },
})

export const getScorePercentage = (score: number, maxScore: number): number => {
  return maxScore > 0 ? Math.round((score / maxScore) * 100) : 0
}

export const scoreDisplayMapping = {
  poor: {
    bgColor: 'var(--danger-100)',
    borderColor: 'var(--danger-300)',
    textColor: 'var(--danger-600)',
    gradeColor: 'var(--danger-600)',
  },
  fair: {
    bgColor: 'var(--warning-100)',
    borderColor: 'var(--warning-300)',
    textColor: 'var(--warning-600)',
    gradeColor: 'var(--warning-600)',
  },
  good: {
    bgColor: 'var(--success-100)',
    borderColor: 'var(--success-300)',
    textColor: 'var(--success-700)',
    gradeColor: 'var(--success-600)',
  },
} as const

export const getNoteDisplay = (percentage: number) => {
  if (percentage >= 65) return scoreDisplayMapping.good
  if (percentage >= 45) return scoreDisplayMapping.fair
  return scoreDisplayMapping.poor
}

export const getScoreColor = (percentage: number): string => {
  if (percentage >= 65) return 'var(--success-500)'
  if (percentage >= 45) return 'var(--warning-500)'

  return 'var(--danger-500)'
}

export const getScoreGrade = (percentage: number): string => {
  if (percentage >= 90) return 'A'
  if (percentage >= 80) return 'B'
  if (percentage >= 70) return 'C'
  if (percentage >= 60) return 'D'
  return 'F'
}
